import React, { useState, useEffect } from "react";

import { useAuth } from "../../contexts/AuthContext";

import { useToast } from "../../contexts/ToastContext";

import leaveService from "../../services/leaveService";

import employeeService from "../../services/employeeService";

import interviewService from "../../services/interviewService";

import { getErrorMessage } from "../../utils/errorHandler";

import PageHeader from "../../components/ui/PageHeader";

import StatCard from "../../components/ui/StatCard";

import LeaveRequestTable from "../../components/common/LeaveRequestTable";

import CalendarPreview from "../../components/common/CalendarPreview";

import {
Users,
  ClipboardList,
  CheckCircle2,
  XCircle,
  AlertCircle,
  Plus,
  Calendar,
  Clock,
  Briefcase,
  Bot,
  Zap,
  UserPlus,
  FileSpreadsheet,

} from "lucide-react";

import { useNavigate } from "react-router-dom";

import "../../styles/dashboard.css";





// Accepte les formats courants renvoyés par l'API : tableau direct
// ou objet contenant data/items/requests/results.
const normalizeList = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.requests)) return value.requests;
  if (Array.isArray(value?.results)) return value.results;
  return [];
};

// Convertit une demande API au format attendu par CalendarPreview.
const mapLeaveRequestForCalendar = (req) => {
  const employee = req?.employee ?? req?.employee_info ?? {};
  const leaveType = req?.leave_type ?? req?.leaveType ?? {};

  const employeeName =
    req?.employee_name ??
    req?.employee_full_name ??
    employee?.full_name ??
    employee?.name ??
    [employee?.first_name ?? employee?.firstName,
     employee?.last_name ?? employee?.lastName]
      .filter(Boolean)
      .join(" ");

  const rawStatus = String(req?.status ?? "").toUpperCase();
  
  const status =
    ["APPROVED", "VALIDATED", "ACCEPTED", "APPROUVE", "APPROUVÉ"].includes(rawStatus)
      ? "Approuvé"
      : ["REJECTED", "REFUSED", "REFUSÉ", "REFUSE"].includes(rawStatus)
      ? "Refusé"
      : ["CANCELLED", "CANCELED", "ANNULE", "ANNULÉ"].includes(rawStatus)
      ? "Annulé"
      : "En attente";


  return {
    id: req?.id ?? req?.leave_request_id ?? req?.request_id,
    employeeName: employeeName || "Employé",
    startDate: String(req?.start_date ?? req?.startDate ?? "").slice(0, 10),
    endDate: String(req?.end_date ?? req?.endDate ?? "").slice(0, 10),
    type:
      req?.leave_type_name ??
      req?.leave_type_label ??
      leaveType?.name ??
      leaveType?.label ??
      req?.type ??
      "Congé",
    status,
  };
};

const RHDashboard = () => {

  const { user } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const [employees, setEmployees] = useState([]);
  const [requests, setRequests] = useState([]);
  const [rhPendingRequests, setRhPendingRequests] = useState([]);
  const [interviewStats, setInterviewStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [attachmentCounts, setAttachmentCounts] = useState({});
  const loadDashboardData = async () => {

    try {

      const [empList, reqList, pendingRH, interviewData] = await Promise.all([
        employeeService.getAll(),
        leaveService.getAllLeaveRequests(),
        leaveService.getLeaveRequestsRH(),
        interviewService.getDashboardStats().catch(() => null)
      ]);

      const employeesData = normalizeList(empList);
      const allRequestsData = normalizeList(reqList);
      const pendingRequestsData = normalizeList(pendingRH);
      const attachmentResults = await Promise.all(
        pendingRequestsData.map(async (request) => {
          const requestId = request?.id ?? request?.leave_request_id;

          if (!requestId) {
            return [String(requestId), null];
          }

          try {
            const result = await leaveService.getAdditionalAttachments(requestId);

            const attachments = Array.isArray(result)
              ? result
              : Array.isArray(result?.data)
              ? result.data
              : Array.isArray(result?.items)
              ? result.items
              : [];

            const hasMainAttachment = Boolean(
              request.attachment_path ||
              request.attachment_original_name ||
              request.has_attachment
            );

            return [
              String(requestId),
              attachments.length + (hasMainAttachment ? 1 : 0),
            ];
          } catch (error) {
            console.error(
              `Erreur de chargement des pièces jointes pour la demande ${requestId}:`,
              error
            );
            return [String(requestId), null];
          }
        })
      );

      setAttachmentCounts(Object.fromEntries(attachmentResults));

      console.log("[RH Dashboard] Réponse brute congés :", reqList);
      console.log("[RH Dashboard] Nombre de demandes :", allRequestsData.length);
      console.table(
        allRequestsData.map((req) => ({
          id: req?.id ?? req?.leave_request_id,
          employee_name: req?.employee_name,
          start_date: req?.start_date ?? req?.startDate,
          end_date: req?.end_date ?? req?.endDate,
          leave_type_name: req?.leave_type_name,
          status: req?.status
        }))
      );

      setEmployees(employeesData);
      setRequests(allRequestsData);
      setRhPendingRequests(pendingRequestsData);
      setInterviewStats(interviewData);

    } catch (err) {

      console.error("Error loading RH dashboard data:", err);

      setEmployees([]);

      setRequests([]);

      setRhPendingRequests([]);

      setInterviewStats(null);

    } finally {

      setLoading(false);

    }

  };



  useEffect(() => {

    loadDashboardData();

  }, []);



 const handleRHAction = async (requestId, approved, comment = "") => {

    try {

      const res = await leaveService.hrDecision(requestId, approved, comment);

      const actionName = res?.status === "APPROVED"

        ? "approuvée (solde débité)"

        : "refusée";

      toast.success(`La demande a été ${actionName}.`);

      loadDashboardData();

    } catch (err) {

      console.error("Error submitting HR decision:", err);

      toast.error(getErrorMessage(err));

    }

  };



  const handleTriggerAccrual = async () => {

    try {

      const res = await leaveService.triggerAccrual();

      toast.success(res.message || "Acquisition mensuelle des congés effectuée (+2j).");

      loadDashboardData();

    } catch (err) {

      console.error("Error triggering accrual:", err);

      toast.error(getErrorMessage(err));

    }

  };



  const handleDateClick = (date) => {

    navigate("/rh/calendar/events/new", { state: { from: "/rh/dashboard", prefillDate: date } });

  };



  if (loading) {

    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>

        <div style={{ textAlign: "center" }}>

          <div className="calendar-loading-spinner" style={{ width: "40px", height: "40px", border: "3px solid var(--border)", borderTopColor: "var(--primary)", borderRadius: "50%", margin: "0 auto 16px" }}></div>

          <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>Chargement du tableau de bord RH...</p>

        </div>

      </div>

    );

  }



  // Statistics calculation

  const totalCount = requests.length;

  const approvedCount = requests.filter((r) => r.status === "APPROVED").length;

  const pendingCount = requests.filter(

    (r) => r.status === "PENDING_MANAGER" || r.status === "PENDING_HR"

  ).length;



  return (

    <div style={{ padding: "24px" }}>

      {/* Page Header */}

      <PageHeader

        title={`Espace RH - ${user?.name || "Administrateur"}`}

        subtitle="Vue d'ensemble de l'entreprise, gestion des effectifs, acquisition et validations RH."

          actions={
            <button
              type="button"
              onClick={() => navigate("/rh/employees")}
              className="btn btn-primary"
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <UserPlus size={16} />
              <span>Nouveau collaborateur</span>
            </button>
          }

      />



          {/* Quick Actions Grid */}

          <section style={{ marginBottom: "28px" }}>

            <div style={{

              display: "flex",

              alignItems: "center",

              gap: "8px",

              marginBottom: "12px",

              fontSize: "0.9rem",

              fontWeight: "700",

              color: "var(--text-main)",

              textTransform: "uppercase",

              letterSpacing: "0.04em"

            }}>

              <Zap size={16} style={{ color: "var(--primary)" }} />

              <span>Actions Rapides</span>

            </div>



            <div style={{

              display: "grid",

              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",

              gap: "12px"

            }}>

              <button

                onClick={() => navigate("/rh/employees")}

                className="ui-card ui-card-interactive"

                style={{

                  padding: "14px 16px",

                  display: "flex",

                  alignItems: "center",

                  gap: "12px",

                  border: "1px solid var(--border)",

                  borderRadius: "var(--radius-md)",

                  backgroundColor: "var(--bg-card)",

                  cursor: "pointer",

                  textAlign: "left"

                }}

              >

                <div style={{ width: "36px", height: "36px", borderRadius: "var(--radius-sm)", backgroundColor: "var(--primary-light)", color: "var(--primary)", display: "grid", placeItems: "center" }}>

                  <UserPlus size={18} />

                </div>

                <div>

                  <div style={{ fontSize: "0.88rem", fontWeight: "700", color: "var(--text-main)" }}>Collaborateur</div>

                  <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>Ajouter un profil</div>

                </div>

              </button>



              <button

                onClick={() => navigate("/rh/job-offers")}

                className="ui-card ui-card-interactive"

                style={{

                  padding: "14px 16px",

                  display: "flex",

                  alignItems: "center",

                  gap: "12px",

                  border: "1px solid var(--border)",

                  borderRadius: "var(--radius-md)",

                  backgroundColor: "var(--bg-card)",

                  cursor: "pointer",

                  textAlign: "left"

                }}

              >

                <div style={{ width: "36px", height: "36px", borderRadius: "var(--radius-sm)", backgroundColor: "var(--secondary-light)", color: "var(--secondary)", display: "grid", placeItems: "center" }}>

                  <Briefcase size={18} />

                </div>

                <div>

                  <div style={{ fontSize: "0.88rem", fontWeight: "700", color: "var(--text-main)" }}>Offre d'emploi</div>

                  <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>Publier un poste</div>

                </div>

              </button>



              <button

                onClick={() => navigate("/rh/calendar/events/new", { state: { from: "/rh/dashboard" } })}

                className="ui-card ui-card-interactive"

                style={{

                  padding: "14px 16px",

                  display: "flex",

                  alignItems: "center",

                  gap: "12px",

                  border: "1px solid var(--border)",

                  borderRadius: "var(--radius-md)",

                  backgroundColor: "var(--bg-card)",

                  cursor: "pointer",

                  textAlign: "left"

                }}

              >

                <div style={{ width: "36px", height: "36px", borderRadius: "var(--radius-sm)", backgroundColor: "var(--accent-light)", color: "var(--accent)", display: "grid", placeItems: "center" }}>

                  <Calendar size={18} />

                </div>

                <div>

                  <div style={{ fontSize: "0.88rem", fontWeight: "700", color: "var(--text-main)" }}>évènement</div>

                  <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>Ajouter au calendrier</div>

                </div>

              </button>



              <button

                onClick={() => navigate("/rh/leaves")}

                className="ui-card ui-card-interactive"

                style={{

                  padding: "14px 16px",

                  display: "flex",

                  alignItems: "center",

                  gap: "12px",

                  border: "1px solid var(--border)",

                  borderRadius: "var(--radius-md)",

                  backgroundColor: "var(--bg-card)",

                  cursor: "pointer",

                  textAlign: "left"

                }}

              >

                <div style={{ width: "36px", height: "36px", borderRadius: "var(--radius-sm)", backgroundColor: "#fef3c7", color: "#d97706", display: "grid", placeItems: "center" }}>

                  <ClipboardList size={18} />

                </div>

                <div>

                  <div style={{ fontSize: "0.88rem", fontWeight: "700", color: "var(--text-main)" }}>Validations RH</div>

                  <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>{rhPendingRequests.length} à traiter</div>

                </div>

              </button>



              <button

                onClick={() => navigate("/rh/assistant")}

                className="ui-card ui-card-interactive"

                style={{

                  padding: "14px 16px",

                  display: "flex",

                  alignItems: "center",

                  gap: "12px",

                  border: "1px solid var(--border)",

                  borderRadius: "var(--radius-md)",

                  backgroundColor: "var(--bg-card)",

                  cursor: "pointer",

                  textAlign: "left"

                }}

              >

                <div style={{ width: "36px", height: "36px", borderRadius: "var(--radius-sm)", backgroundColor: "#f3e8ff", color: "#7c3aed", display: "grid", placeItems: "center" }}>

                  <Bot size={18} />

                </div>

                <div>

                  <div style={{ fontSize: "0.88rem", fontWeight: "700", color: "var(--text-main)" }}>Assistant IA</div>

                  <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>Poser une question</div>

                </div>

              </button>

              
<button
  onClick={() => navigate("/rh/leave-annual-report")}
  className="ui-card ui-card-interactive"
  style={{
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius-md)",
    backgroundColor: "var(--bg-card)",
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
  }}
>
  <div
    style={{
      width: "36px",
      height: "36px",
      borderRadius: "var(--radius-sm)",
      backgroundColor: "#dcfce7",
      color: "#15803d",
      display: "grid",
      placeItems: "center",
      flexShrink: 0,
    }}
  >
    <FileSpreadsheet size={18} />
  </div>

  <div>
    <div
      style={{
        fontSize: "0.88rem",
        fontWeight: "700",
        color: "var(--text-main)",
      }}
    >
      Rapport des congés
    </div>

    <div
      style={{
        fontSize: "0.75rem",
        color: "var(--text-muted)",
      }}
    >
      Consulter les soldes par année
    </div>
  </div>
</button>



            </div>

          </section>



          {/* Stats Cards Grid */}

          <section style={{ marginBottom: "28px" }}>

            <div style={{

              display: "grid",

              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",

              gap: "16px"

            }}>

              <StatCard

                title="Collaborateurs"

                value={employees.length}

                subtitle={`${employees.filter(e => e.is_active !== false).length} actifs`}

                icon={Users}

                iconBg="var(--primary-light)"

                iconColor="var(--primary)"

                onClick={() => navigate("/rh/employees")}

              />



              <StatCard

                title="Congés à valider"

                value={rhPendingRequests.length}

                subtitle={`${pendingCount} demandes globales`}

                icon={AlertCircle}

                iconBg="#fef3c7"

                iconColor="#d97706"

                onClick={() => navigate("/rh/leaves")}

              />



              <StatCard

                title="Congés Approuvés"

                value={approvedCount}

                subtitle={`Sur ${totalCount} demandes au total`}

                icon={CheckCircle2}

                iconBg="var(--secondary-light)"

                iconColor="var(--secondary)"

                onClick={() => navigate("/rh/leaves/history")}

              />



              <StatCard

                title="Entretiens à Venir"

                value={interviewStats?.upcoming?.length || "0"}

                subtitle={`${interviewStats?.today || 0} prévu(s) aujourd'hui`}

                icon={Calendar}

                iconBg="var(--accent-light)"

                iconColor="var(--accent)"

                onClick={() => navigate("/rh/applications")}

              />

            </div>

          </section>



          {/* Pending Requests Table */}

          <section style={{ marginBottom: "28px" }}>

            <div className="ui-card" style={{ padding: "20px" }}>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>

                <div>

                  <h3 style={{ fontSize: "1.1rem", fontWeight: "700", color: "var(--text-main)", margin: 0 }}>

                    Demandes de congés à valider

                  </h3>

                  <p style={{ fontSize: "0.85rem", color: "var(--text-muted)", margin: "2px 0 0 0" }}>

                    Signez et validez définitivement les congés des employés.

                  </p>

                </div>

                <button onClick={() => navigate("/rh/leaves")} className="btn btn-outline" style={{ fontSize: "0.85rem" }}>

                  Voir tout

                </button>

              </div>


              <LeaveRequestTable
                requests={rhPendingRequests.map((request) => {
                  const requestId = String(
                    request?.id ?? request?.leave_request_id
                  );

                  return {
                    ...request,
                    attachment_count: attachmentCounts[requestId],
                  };
                })}
                role="rh"
                onAction={(id, action) =>
                  handleRHAction(
                    id,
                    action === "Approuver",
                    action === "Approuver"
                      ? "Validé par les RH"
                      : "Refusé par les RH"
                  )
                }
              />

            </div>

          </section>



          {/* Calendar Section */}

          <section style={{ marginBottom: "28px" }}>

            <div className="ui-card" style={{ padding: "20px" }}>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>

                <div>

                  <h3 style={{ fontSize: "1.1rem", fontWeight: "700", color: "var(--text-main)", margin: 0 }}>

                    Calendrier RH des absences

                  </h3>

                  <p style={{ fontSize: "0.85rem", color: "var(--text-muted)", margin: "2px 0 0 0" }}>

                    Planning global des événements et congés de l'entreprise.

                  </p>

                </div>

                <button

                  onClick={() => navigate("/rh/calendar/events/new", { state: { from: "/rh/dashboard" } })}

                  className="btn btn-primary"

                  style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "0.85rem" }}

                >

                  <Plus size={16} />

                  <span>Ajouter un jour férié</span>

                </button>

              </div>



              <CalendarPreview
                requests={requests.map(mapLeaveRequestForCalendar)}
                onDateClick={handleDateClick}
                showEmployeeName={true}
              />



            </div>

          </section>

    </div>

  );

};



export default RHDashboard;
